// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__28_Wz","overflowing":"ReadFullNote_overflowing__oVKVa"};